
define('ldsh!modules/form_editor/templates/editor_text', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="editor-form-group ed-form-group">\n    <label class="control-label" for="" data-i18n="[text]formEditor.placeholder">Texto por defecto</label>\n    <input type="text"\n           class="form-control js-placeholder"\n           value="' +
((__t = ( placeholder )) == null ? '' : __t) +
'"\n    />\n</div>\n';

}
return __p
};});

